import React, {useState, useEffect} from 'react'
import Layout from '../../../components/Layout/Layout'
import axios from 'axios'
import toast from 'react-hot-toast';
import { Button, Modal } from 'react-bootstrap';
import { dateInDMY, hasRight, isAdmin } from '../../../Helpers';
import { SERVER_API } from '../../../fileWithConstants';
import { useAuth } from '../../../context/auth';
import "react-datepicker/dist/react-datepicker.css";
import { Link } from 'react-router-dom';
import { FaExclamationCircle, FaRegCheckCircle } from 'react-icons/fa';
import PoInwarddetails from './PoInwarddetails';
const InwardPoElementList = () => {
    const [auth, setAuth] = useAuth();
    const [userId, setUserId] = useState(auth.user.id);
    const admin_right = isAdmin(auth.user);
    const fabric_in_approve_right = hasRight(auth.user, 'fabric_in_approve');

    const [podata, setPodata]=useState([]);
    const [poshow, setPoshow] = useState(false);
    const [selected_po_id, setSelected_po_id]=useState('');
    const [selected_invoice, setSelected_invoice]=useState('');
    const [poChildData, setPoChildData] = useState([]);
    const [podatashow, setPodatashow] = useState(false);
    const getPoInwarddata= async()=>{
        try {
            const {data} = await axios.get(`${SERVER_API}/api/v1/element/get-inward-po-element-data`);
            if(data?.success && data?.podata.length>0){
                setPodata(data?.podata);
            }else{
              toast.error('Some thing went wrong while getting PO data.')
            }
        } catch (error) {
            console.log(error)
        }
    }

useEffect(()=>{
            getPoInwarddata();
        },[])

const HandleApproveModel = (id, po_number)=>{
    if(!fabric_in_approve_right && !admin_right){
        alert('You have no right to approve.');
        return false;
    }
    setSelected_po_id(id);
    setSelected_invoice(po_number);
    setPoshow(true);
}

const handleClose = ()=> {
    setPoshow(false);
    setPodatashow(false);
};

const handleApprove = async()=>{
    const formData = new FormData();
    formData.append("inw_id", selected_po_id);
    formData.append("user_id", userId);
    const {data} = await axios.put(`${SERVER_API}/api/v1/element/po-element-inward-approve`,formData,{
        headers:{'Content-Type':'application/json'}
    });
    if(data?.success){
        toast.success(data.message);
        getPoInwarddata();
        setPoshow(false)
    }
}

const handleShowPodata = async(id, invoice_no)=>{
   setPodatashow(true)
   setSelected_invoice(invoice_no)
    const {data} = await axios.get(`${SERVER_API}/api/v1/element/get-single-inw-po-element-data/${id}`);
    //console.log(data)
    if(data?.success && data?.posingledata.length>0){
        setPoChildData(data?.posingledata);
    }else{
        toast.error('Some thing went wrong while getting PO inward data.')
    }
    setPodatashow(true)
}


  return (
    <Layout title={'Po Inward Element List Page'}>
        <div className='container'>
            <div className='justify-content-center'>
                    <h1 className='page-title text-center'>PO Inward Element List</h1> 
                    <div className="row">
                    <div className="col-md-12">
                    <div className='table-box'>
                        <table className="table table-responsive table-hover table-sticky">
                            <thead>
                                <tr className='align-item'>
                                    <th scope="col">#</th>
                                    <th scope="col" className='text-center'>Invoice No.</th>
                                    <th scope="col" className='text-center'>Invoice Date</th>
                                    <th scope="col" className='text-center'>Amount</th>
                                    <th scope="col" className='text-center'>Inward Date</th>
                                    <th scope="col" className='text-center'>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {podata?.map((po, index)=>(
                                    <tr key={index}>
                                        <td>{index+1}</td>
                                        <td className='text-start' onClick={()=>{handleShowPodata(po.id, po.invoice_no)}}>
                                        <Link to={'#'}>
                                        {po.invoice_no}
                                        </Link>
                                        </td>
                                        <td className='text-center'>{dateInDMY(po.invoice_date)}</td>
                                        <td className='text-center'>{po.invoice_amount}</td>
                                        <td className='text-center'>{dateInDMY(po.inw_at)}</td>
                                        <td className='text-center'>
                                            {po.approve_status===1?<Link to={'#'}><span><FaRegCheckCircle className='text-success'/> Approved</span></Link>:<Link to={'#'}><span onClick={()=>{HandleApproveModel(po.id,po.invoice_no)}}><FaExclamationCircle className='text-danger'/> Pending</span></Link>}                                        
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    </div>
                </div>
            </div>
        </div>

        <Modal show={poshow} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title>Invoice number: {selected_invoice}</Modal.Title>
            </Modal.Header>
            <Modal.Body><FaExclamationCircle className='text-warning'/> Are you sure, you want to approve Invoice number: <b>{selected_invoice}</b> ?</Modal.Body>
            <Modal.Footer>
            <Button variant="success" onClick={handleApprove}>Yes</Button>
            <Button variant="danger" onClick={handleClose}>No</Button>
            </Modal.Footer>
        </Modal>

        
        <Modal size="lg" show={podatashow} onHide={handleClose}>
            <Modal.Header closeButton>
            <Modal.Title>Invoice number: {selected_invoice}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PoInwarddetails poChildData={poChildData}/>
            </Modal.Body>
        </Modal>

    </Layout>
  )
}

export default InwardPoElementList
